<template>
  <section id="form">
    <a class="goback" @click="$router.go(-1)">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        fill="currentColor"
        class="bi bi-x-lg"
        viewBox="0 0 16 16"
      >
        <path
          d="M1.293 1.293a1 1 0 0 1 1.414 0L8 6.586l5.293-5.293a1 1 0 1 1 1.414 1.414L9.414 8l5.293 5.293a1 1 0 0 1-1.414 1.414L8 9.414l-5.293 5.293a1 1 0 0 1-1.414-1.414L6.586 8 1.293 2.707a1 1 0 0 1 0-1.414z"
        />
      </svg>
    </a>
    <section class="block-content mb-5">
      <div class="container content-midwide my-5 py-5">
        <form @submit="submitForm" id="application-form">
          <div
            class="pending align-items-center justify-content-center"
            v-if="isSending"
          >
            <svg
              version="1.1"
              width="100"
              height="100"
              id="L9"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              x="0px"
              y="0px"
              viewBox="0 0 100 100"
              enable-background="new 0 0 0 0"
              xml:space="preserve"
            >
              <path
                fill="#cc071e"
                d="M73,50c0-12.7-10.3-23-23-23S27,37.3,27,50 M30.9,50c0-10.5,8.5-19.1,19.1-19.1S69.1,39.5,69.1,50"
              >
                <animateTransform
                  attributeName="transform"
                  attributeType="XML"
                  type="rotate"
                  dur="1s"
                  from="0 50 50"
                  to="360 50 50"
                  repeatCount="indefinite"
                />
              </path>
            </svg>
          </div>
          <h2>Bewerbung auf die Stelle<br />{{ $parent.job.title }}</h2>
          <input type="hidden" :value="$parent.job.title" name="job" id="job" />
          <div class="form-floating mb-3">
            <input
              type="text"
              :class="{ 'is-invalid': form_errors.name }"
              class="form-control border-bottom-only"
              name="name"
              id="name"
              placeholder="dein Name"
              v-model="form.name"
            />
            <label for="name">Name *</label>
          </div>
          <div class="form-floating mb-3">
            <input
              type="email"
              :class="{ 'is-invalid': form_errors.mail }"
              class="form-control border-bottom-only"
              name="mail"
              id="email"
              placeholder="max@msutermann.de"
              v-model="form.mail"
            />
            <label for="email">E-Mail *</label>
          </div>
          <div class="form-floating mb-3">
            <input
              type="tel"
              :class="{ 'is-invalid': form_errors.phone }"
              class="form-control border-bottom-only"
              name="phone"
              id="phone"
              placeholder="0351 810 77 33"
              v-model="form.phone"
            />
            <label for="phone">Rückrufnummer *</label>
          </div>
          <div class="form-floating mb-3">
            <textarea
              :class="{ 'is-invalid': form_errors.message }"
              class="form-control border-bottom-only"
              name="message"
              id="message"
              style="min-height: 17.5rem; height: auto"
              placeholder="Dein Anliegen kannst du uns hier schildern"
              v-model="form.message"
            ></textarea>
            <label for="message">Anschreiben *</label>
          </div>
          <label for="file_1" class="d-flex flex-wrap"
            ><span class="flex-fill">Lebenslauf * </span
            ><small>(Bitte PDF-Format nutzen)</small></label
          >
          <div class="input-group mb-3">
            <input
              name="life"
              type="file"
              :class="{ 'is-invalid': form_errors.file_1 }"
              class="form-control"
              ref="file_1"
              id="file_1"
              @change="checkFile"
            />
          </div>
          <p class="d-block text-danger" v-if="uploadErrors['file_1']">
            {{ uploadErrors["file_1"] }}
          </p>
          <label for="file_2" class="d-flex flex-wrap"
            ><span class="flex-fill">Arbeitsproben</span>
            <small>(Bitte PDF-Format nutzen)</small></label
          >
          <div class="input-group mb-3">
            <input
              name="work"
              type="file"
              class="form-control"
              :class="{ 'is-invalid': form_errors.file_2 }"
              ref="file_2"
              id="file_2"
              @change="checkFile"
            />
          </div>
          <p class="d-block text-danger" v-if="uploadErrors['file_2']">
            {{ uploadErrors["file_2"] }}
          </p>
          <div
            class="alert mt-3"
            :class="{
              'alert-success': callback.success,
              'alert-danger': !callback.success,
            }"
            v-if="callback"
            v-html="callback.message"
          ></div>
          <p class="text-muted small py-3">
            Die von Ihnen übermittelten Daten speichern und verwenden wir
            ausschließlich für den Zweck, für den Ihre Angabe erfolgte. Weitere
            Informationen finden Sie in unseren
            <router-link
              :to="{ name: 'policy' }"
              target="_blank"
              class="inherit"
              >Datenschutzinformationen</router-link
            >.
          </p>
          <button
            type="submit"
            class="btn btn-outline-ito hover-red animated-arrow"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              fill="currentColor"
              class="bi bi-arrow-right-short"
              viewBox="0 0 16 16"
            >
              <path
                fill-rule="evenodd"
                d="M4 8a.5.5 0 0 1 .5-.5h5.793L8.146 5.354a.5.5 0 1 1 .708-.708l3 3a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708-.708L10.293 8.5H4.5A.5.5 0 0 1 4 8z"
              /></svg
            >Jetzt Bewerbung senden
          </button>
        </form>
      </div>
    </section>
  </section>
</template>

<style scoped>
#form {
  position: fixed;
  background: #fff;
  z-index: 10000;
  left: 0;
  top: 0;
  height: 100%;
  right: 0;
  display: block;
  overflow: auto;
}
small {
  font-size: 0.8rem;
}
</style>

<script>
import store from '@/store'
import axios from 'axios'

export default {
  name: 'Form',
  data: function () {
    return {
      uploadErrors: {
        file_1: '',
        file_2: ''
      },
      form: {
        name: '',
        mail: '',
        phone: '',
        message: '',
        file_1: '',
        file_2: ''
      },
      form_errors: {
        name: false,
        mail: false,
        phone: false,
        message: false,
        file_1: false,
        file_2: false
      },
      callback: null,
      isSending: false
    }
  },
  methods: {
    checkFile (e) {
      const file = e.target.files[0]
      const el = e.target.id
      if (file.type !== 'application/pdf') {
        if (el === 'file_1') {
          this.uploadErrors.file_1 = 'Das Dateiformat wird nicht akzeptiert. Bitte verwende PDF-Files für deinen Upload!'
          this.form_errors.file_1 = true
          this.$refs.file_1.value = ''
        }
        if (el === 'file_2') {
          this.uploadErrors.file_2 = 'Das Dateiformat wird nicht akzeptiert. Bitte verwende PDF-Files für deinen Upload!'
          this.form_errors.file_2 = true
          this.$refs.file_2.value = ''
        }
      } else {
        if (el === 'file_1') {
          this.uploadErrors.file_1 = ''
          this.form.file_1 = file
          this.form_errors.file_1 = false
        }
      }
    },
    submitForm (e) {
      e.preventDefault()
      // validation
      this.form_errors.name = this.form.name === ''
      this.form_errors.mail = this.form.mail === ''
      this.form_errors.phone = this.form.phone === ''
      this.form_errors.message = this.form.message === ''
      this.form_errors.file_1 = this.form.file_1 === ''
      if (
        this.form_errors.message ||
        this.form_errors.phone ||
        this.form_errors.mail ||
        this.form_errors.name ||
        this.form_errors.file_1
      ) { return false }
      this.isSending = true
      const myForm = document.getElementById('application-form')
      const formData = new FormData(myForm)
      axios
        .post(
          'https://ito-consult.de/mail-application-form.php',
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }
        )
        .then((res) => {
          this.callback = res.data
          if (this.callback.success) {
            document.getElementById('application-form').reset()
            this.form.file_2 = ''
            this.form.file_1 = ''
            this.form.message = ''
            this.form.phone = ''
            this.form.mail = ''
            this.form.name = ''
          }
          this.isSending = false
        })
    }
  },
  beforeMount () {
    store.commit('noScollBodyStatus', true)
    store.commit('loadingStatus', false)
  },
  beforeDestroy () {
    // hide single view compontent on unload (history back bug)
    store.commit('loadingStatus', false)
  }
}
</script>
<style scoped>
.inherit {
  color: inherit;
}
.goback {
  position: absolute;
  top: 2rem;
  right: 2rem;
  cursor: pointer;
  color: var(--ito-red);
  z-index: 10000;
}

form .pending {
  content: '';
  display: flex;
  left: 0;
  bottom: 0;
  right: 0;
  top: 0;
  background: #fff;
  z-index: 10;
  opacity: 0.5;
  position: absolute;
}
</style>
